import { Fragment } from "react";
import {
  IntegratedPaymentsSection,
  PaymentsPoweredByZbooniSection,
} from "app/sections/accept-payments";
import { getLoaderTrans } from "app/.server/utils";
import { getMeta } from "app/utils/meta";

export const loader = async ({ request, params }) => {
  const trans = await getLoaderTrans({ request, params });
  return {
    meta: {
      title: `${trans("Features")} | ${trans("Modern tools for a new era of commerce")}`,
      description: trans(
        "Designed from the ground up, we offer purpose-built tools for personalized commerce. Customers checkout faster, safer, and more conveniently than ever."
      ),
    },
  };
};

export const meta = ({ loaderData: data }) =>
  getMeta({ title: data.meta.title, description: data.meta.description });

export default function FeatureAcceptPaymentsPage() {
  return (
    <Fragment>
      <PaymentsPoweredByZbooniSection />
      <IntegratedPaymentsSection />
    </Fragment>
  );
}
